
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * CommissionMode enum
 */
class CommissionMode {
  /**
   * Initialize enum with a given value
   * @param {CommissionMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof CommissionMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!CommissionMode}
   * @param {!CommissionMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CommissionMode)) {
      throw new TypeError('Instance of CommissionMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!CommissionMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!CommissionMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === CommissionMode.PERCENTS.value) {
      return 'PERCENTS'
    }
    if (this.value === CommissionMode.PRIMARY_CURRENCY.value) {
      return 'PRIMARY_CURRENCY'
    }
    if (this.value === CommissionMode.MONEY_USD.value) {
      return 'MONEY_USD'
    }
    if (this.value === CommissionMode.POINTS.value) {
      return 'POINTS'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!CommissionMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!CommissionMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!CommissionMode} Created enum
   */
  static fromObject (other) {
    return new CommissionMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
CommissionMode.PERCENTS = new CommissionMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
CommissionMode.PRIMARY_CURRENCY = new CommissionMode(0 + 1)
// noinspection PointlessArithmeticExpressionJS
CommissionMode.MONEY_USD = new CommissionMode(0 + 2)
// noinspection PointlessArithmeticExpressionJS
CommissionMode.POINTS = new CommissionMode(0 + 3)

export { CommissionMode };

/**
 * Fast Binary Encoding CommissionMode field model
 */
class FieldModelCommissionMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelCommissionMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelCommissionMode}
   * @param {CommissionMode=} defaults Default value, defaults is new CommissionMode()
   * @returns {!CommissionMode} Result value
   */
  get (defaults = new CommissionMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new CommissionMode(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelCommissionMode}
   * @param {!CommissionMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelCommissionMode };
